// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';
import { Color } from 'three';

export const GOLDEN_ANGLE = 0.38196601125010515;
const minLightness = 0.4;
const maxLightness = 0.6;

export const getColorForColorScheme = (i: number, startHue: number, saturation: number) =>
  `#${new Color().setHSL((startHue + GOLDEN_ANGLE * i) % 1, saturation, i % 2 === 0 ? minLightness : maxLightness).getHexString()}` as HexTriplet;

// Simple color scheme generator. Alternate light/dark, move hue by a golden angle.
export const createColorScheme = (size: number, startHue = 0.1, saturation = 0.5): HexTriplet[] => {
  const colorScheme: HexTriplet[] = Array(size);
  for (let i = 0; i < size; i++) {
    colorScheme[i] = getColorForColorScheme(i, startHue, saturation);
  }
  return colorScheme;
};
